import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import PlayAudio from '@Images/play_audio.svg'
import PauseAudio from '@Images/pause_audio.svg'
import Close from '@Images/close_new.svg'
import { safeMediaPlay } from '@Utils/SafeMediaPlay'

interface TrainingSampleProps {
  readonly fileName: string
  readonly url?: string
  readonly progress?: number
  readonly duration?: string
  readonly allowRemoval?: boolean
  readonly onRemove: () => void
}

const TrainingSample: React.FC<TrainingSampleProps> = props => {
  const {
    fileName,
    url,
    progress,
    duration,
    allowRemoval,
    onRemove,
  } = props

  const [audio, _] = useState<HTMLAudioElement>(() => {
    const audioElement = new Audio()

    audioElement.addEventListener('play', () => setPlaying(true))
    audioElement.addEventListener('pause', () => setPlaying(false))
    audioElement.addEventListener('ended', () => setPlaying(false))

    return audioElement
  })
  const [playing, setPlaying] = useState(false)

  useEffect(() => {
    return () => {
      audio.pause()
      audio.src = ''
      audio.load()
    }
  }, [])

  useEffect(() => {
    if (!url) { return }

    audio.src = url
    audio.load()
  }, [url])

  const togglePlaying = () => {
    if (!url) { return }

    if (playing) {
      audio.pause()
    } else {
      safeMediaPlay(audio, { context: 'TrainingSample togglePlaying' })
    }
  }

  return (
    <div className="TrainingSamples__file">
      <div className="TrainingSamples__file-left">
        <div
          className={classnames('TrainingSamples__file-icon', {
            'TrainingSamples__file-icon--disabled': !url,
          })}
          onClick={togglePlaying}
        >
          {playing ? (
            <PauseAudio />
          ) : (
            <PlayAudio />
          )}
        </div>
        <div className="TrainingSamples__file-data">
          <div className="TrainingSamples__file-name">{fileName}</div>
          <div className="TrainingSamples__file-duration-or-progress">{duration || `${progress}%`}</div>
        </div>
      </div>
      {allowRemoval && (
        <div
          className="TrainingSamples__file-remove"
          onClick={onRemove}
        >
          <Close />
        </div>
      )}
    </div>
  )
}

export default TrainingSample
